<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card"
           qa="auth-modal"
           role="dialog"
           aria-modal="active"
           aria-labelledby="auth-modal"
           tabindex="-1">
      <!-- Modal Trapping Section -->
      <div aria-hidden="true"
           tabindex="0" />
      <!-- Modal Trapping Ends -->
      <button aria-label="To close modal"
              class="close gtm-login-close cursor-pointer"
              ref="first_element"
              @click="closeStudentCode()">
        <i class="fal fa-times" />
      </button>
      <section class="section">
        <div>
          <div v-if="!editStudentByTeacher">
            <span class="title welcome-modal" qa="signup-modal-title">{{ $t('teacherRegistration.studentRegistration') }}</span>
          </div>
          <div v-if="editStudentByTeacher">
            <span class="title welcome-modal" qa="signup-modal-title">STUDENT ACCOUNT</span>
          </div>
          <div class="container">
            <div v-if="!showStudentSignUp" class="signup-inputs">
              <div class="enter-code"
                   tabindex="0">Enter the code provided by your teacher
              </div>
              <Input ref="studentCode"
                     class="signup"
                     :type="'text'"
                     :name="'studentCode'"
                     :value="studentCode"
                     v-model="studentCode"
                     :center="true"
                     :disabled="waiting"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <div v-if="error" class="help has-text-danger error">{{error}}</div>
              </div>
              <!-- Username Input -->
            <div v-if="showStudentSignUp" class="signup-inputs">
              <br>
              <div v-if="!editStudentByTeacher" class="enter-code"
                   tabindex="0">{{ usernamePlaceholder }} <strong>{{studUsername}}</strong>
              </div>
              <Input v-if="editStudentByTeacher" ref="studUsername" class="signup" :type="'text'" :name="'studUsername'" :value="studUsername" v-model="studUsername" :center="true" :disabled="waiting"
                     placeholder="Student username"
                     label="Student username"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <Input v-if="allowStudentNameEdit"
                     ref="studentName" class="signup" :type="'text'" :name="'studentName'" :value="studentName" v-model="studentName" :center="true" :disabled="waiting"
                     :placeholder="studentNamePlaceholder"
                     :label="studentNamePlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <Input ref="studPassword" class="signup" type="password" :name="'studPassword'" v-model="studPassword" :value="studPassword" :center="true" :disabled="waiting"
                     :placeholder="studentPasswordPlaceholder"
                     :label="studentPasswordPlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <div v-if="error" class="help has-text-danger error">{{error}}</div>
            </div>
          </div>

          <div class="next-button-container">
            <button class="button is-outlined is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    @click="closeStudentCode" :disabled="waiting"
                    qa="signup-continue-btn">
              {{ $t("cancel")}}
            </button>
            <button v-if="!showStudentSignUp" class="button is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    @click="checkStudentCodeInDB" :disabled="waiting"
                    qa="signup-continue-btn">
              {{ $t("save")}}
            </button>
            <button v-if="showStudentSignUp && !editStudentByTeacher && !addNewStudentByTeacher" class="button is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    @click="studentSignUpByCode" :disabled="waiting"
                    qa="signup-continue-btn">
              {{ $t("save")}}
            </button>
            <button v-if="showStudentSignUp && editStudentByTeacher && !addNewStudentByTeacher" class="button is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    @click="editStudentDataByTeacher" :disabled="waiting"
                    qa="signup-continue-btn">
              {{ $t("save")}}
            </button>
            <button v-if="showStudentSignUp && !editStudentByTeacher && addNewStudentByTeacher" class="button is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    @click="addStudentByTeacher" :disabled="waiting"
                    qa="signup-continue-btn">
              {{ $t("teacherRegistration.createStudent")}}
            </button>
          </div>
        </div>
      </section>
      <div aria-hidden="true"
           @focus="selectFirstElement()"
           tabindex="0" />
    </aside>
  </div>
</template>

<script>
import auth from '@/libs/auth'
import userAgent from '@/libs/user-agent'
import link from '@/mixins/link'
import signup from '@/mixins/signup'
import i18n from '@/i18n'
import Input from '@/components/Controls/Input'
import componentState from '@/mixins/component-state'
import gaTrackingMixin from '@/mixins/ga-tracking'
export default {
  components: {
    Input,
    i18n
  },
  props: ['currentStudent', 'editStudentByTeacher', 'addNewStudentByTeacher', 'classId', 'selectedClass'],
  mixins: [componentState, link, signup, gaTrackingMixin],
  data: function () {
    return {
      waiting: false,
      error: '',
      showStudentCode: false,
      studentCode: '',
      showStudentSignUp: false,
      studentName: '',
      studUsername: '',
      studPassword: '',
      teacherUId: 0,
      usernamePlaceholder: '',
      studentNamePlaceholder: '',
      studentPasswordPlaceholder: ''
    }
  },
  mounted: function () {
    this.getStudQuestionId()
    this.editStudentUsernameText()
    if (this.currentStudent) {
      if (this.currentStudent.userAnswer !== null) {
        this.studentName = this.currentStudent.userAnswer.answer
      } else {
        this.studentName = this.currentStudent.firstName
      }
      this.studUsername = this.currentStudent.userName
      this.studPassword = this.currentStudent.password
      this.showStudentSignUp = true
    }
    if (this.addNewStudentByTeacher) {
      this.createUserName()
      this.teacherUId = this.currentUser.id
      this.showStudentSignUp = true
    }
  },
  watch: {
    keyName: function (key) {
      this._setObjectKey(key)
    }
  },
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    isMobile: function () {
      return userAgent.isApp() || userAgent.isIOS() || userAgent.isAndroid()
    },
    teacherGroup: function () {
      if (this.selectedClass) {
        return this.selectedClass
      }
      return this.$store.getters.teacherGroup
    },
    currentUser: function () {
      return this.$store.getters.currentUser
    },
    questionId: function () {
      return this.$store.getters.studentQuestionId
    },
    allowStudentNameEdit: function () {
      return !this.$isOhioScience
    }
  },
  methods: {
    selectFirstElement: function () {
      this.$refs.first_element.focus()
    },
    checkStudentCodeInDB: function () {
      this.error = null
      this.waiting = true
      if (!this.studentCode) {
        this.waiting = false
        this.error = 'Please enter code provided by your teacher.'
      } else {
        this.$store.dispatch('getGroupByCode', this.studentCode).then((group) => {
          if (group && group.id !== 0) {
            this.createUserName()
            this.teacherUId = group.userId
            this.error = null
            this.showStudentSignUp = true
            this.waiting = false
          } else if (group === null) {
            this.waiting = false
            this.error = 'The code entered does not exist. Please try again.'
          }
        })
      }
    },
    studentSignUpByCode: function () {
      this.waiting = true
      if (!this.studentName) {
        this.waiting = false
        this.error = 'Please enter name.'
      } else if (!this.studPassword) {
        this.waiting = false
        this.error = 'Please enter password'
      } else if (this.studPassword.length < 4) {
        this.waiting = false
        this.error = 'Password should be at least 4 characters.'
      } else {
        const params = {
          userName: this.studUsername,
          email: 'teachercode+' + this.studUsername + '@projectboard.com',
          password: this.studPassword,
          redirectParam: this.redirectParam,
          signupSource: 'TeacherCode',
          teacherUId: this.teacherUId
        }
        this.$store.dispatch('signup', params).then((user) => {
          this.createGroupUser(user)
          this.storeStudentName(this.studentName, user.id, 'Create')
          this.userVerified = true
          if (!this.addNewStudentByTeacher) {
            this.newUser = true
            this.user = user
            this.loginWithTeacherCode()
            this.$router.push({ path: '/' })
          }
          this.waiting = false
          this.closeStudentCode()
        }, (error) => {
          this.waiting = false
          this.error = error.message
        })
      }
    },
    loginWithTeacherCode: function () {
      if (!this.studPassword) {
        this.error = 'Please enter your password'
        return
      }
      this.error = ''
      this.waiting = true
      this.$store.dispatch('login', { username: this.studUsername, password: this.studPassword }).then((tokens) => {
        auth.storeTokens(tokens)
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    closeStudentCode: function () {
      this.$emit('closeStudentCode')
      if (this.addNewStudentByTeacher) {
        this.$emit('closeCreateStudent')
      } else if (this.editStudentByTeacher) {
        this.$emit('doneEditStudent')
      }
    },
    editStudentDataByTeacher: function () {
      this.error = ''
      this.waiting = true
      const params = {
        userId: this.currentStudent.id,
        userName: this.studUsername,
        password: this.studPassword,
        firstName: this.studentName
      }
      this.$store.dispatch('updateStudentData', params).then((response) => {
        let confirmCreateOrUpdate = ''
        if (this.currentStudent.userAnswer == null) {
          confirmCreateOrUpdate = 'Create'
        } else {
          confirmCreateOrUpdate = 'Update'
        }
        this.storeStudentName(this.studentName, this.currentStudent.id, confirmCreateOrUpdate)
        this.$emit('doneEditStudent')
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    createUserName: function () {
      this.$store.dispatch('createUserName').then((userName) => {
        this.studUsername = userName
      })
    },
    createGroupUser: function (user) {
      const params = {
        groupId: this.teacherGroup.id,
        teacherUId: this.teacherGroup.userId,
        userId: user.id,
        className: this.teacherGroup.name
      }
      this.$store.dispatch('createGroupUser', params).then((response) => {
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    storeStudentName: function (studName, userId, confirmCreateOrUpdate) {
      const params = {
        name: studName,
        userId: userId,
        questionId: this.questionId,
        teacherId: this.teacherUId,
        confirmCreateOrUpdate: confirmCreateOrUpdate
      }
      this.$store.dispatch('storeStudentName', params).then((response) => {
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    addStudentByTeacher: function () {
      this.waiting = true
      if (!this.studPassword) {
        this.waiting = false
        this.error = 'Please enter password'
      } else if (this.studPassword.length < 4) {
        this.waiting = false
        this.error = 'Password should be at least 4 characters.'
      } else {
        const params = {
          userName: this.studUsername,
          email: 'teachercode+' + this.studUsername + '@projectboard.com',
          password: this.studPassword,
          redirectParam: this.redirectParam,
          signupSource: 'AddStudentByTeacher',
          teacherUId: this.teacherUId
        }
        this.$store.dispatch('addStudentByTeacher', params).then((user) => {
          this.createGroupUser(user)
          this.storeStudentName(this.studentName, user.id, 'Create')
          this.userVerified = true
          this.waiting = false
          this.$emit('closeCreateStudent')
        }, (error) => {
          this.waiting = false
          this.error = error.message
        })
      }
    },
    editStudentUsernameText: function () {
      if (this.addNewStudentByTeacher) {
        this.usernamePlaceholder = this.$t('teacherRegistration.studentUsername')
        this.studentNamePlaceholder = this.$t('teacherRegistration.enterStudentName')
        this.studentPasswordPlaceholder = this.$t('teacherRegistration.studentPassword')
      } else if (this.editStudentByTeacher) {
        this.studentNamePlaceholder = 'Student name'
        this.studentPasswordPlaceholder = 'Student password (Optional)'
      } else {
        this.usernamePlaceholder = 'This is your username: '
        this.studentNamePlaceholder = 'Enter your name (only your teacher will see this)'
        this.studentPasswordPlaceholder = this.$t('login.studPassword')
      }
    },
    getStudQuestionId: function () {
      this.$store.dispatch('getStudentQuestionId').then((response) => {
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

$modal-body-color: #F2F2F2;
$modal-footer-color: #F7F7F7;
$close-icon-color: #1A051D;
$border-color: #DCDCDC;
$placeholder-font-color: #565656;
$input-background-color: #FFFFFF;
$input-height: 40px;
$bottom-message-font-color: #3F3F3F;

.modal {
  z-index: 50;
}

.modal-card {
  background: $modal-body-color;
  padding: 1.3rem 0 0;
  text-align: center;
  overflow: auto;
@include mobile {
  max-width: 98vw;
}
}

.close {
  top: 0.4rem;
  right: 1rem;
  position: absolute;
  font-size: 1.5rem;
  color:  $close-icon-color;
  border: none;
  padding: 0;
  background: transparent;
&:hover {
   color: $link-hover;
 }
}
.section {
  height: auto;
  padding: 0;

.container {
  margin: auto;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 500px;
@include mobile {
  width: 300px;
  max-width: 300px;
}
@media screen and (max-height: 375px) {
  margin-top: auto;
}
}
}

.title {
  font-family: $primary-font;
  font-weight: $primary-font-weight;
@include mobile{
  font-size: 1.75rem;
}
}

.button {
  border-radius: 0;
  padding: 1rem 1.5rem;
  text-transform: uppercase;
  font-size: 0.9rem;
&.continue-button {
   margin: 1.1rem 0 1.1rem;
   padding: 1.15rem 1.2rem;
 }
&.using-password-button {
   margin: 0 0 1.5rem;
 }
}
.button[disabled] {
  pointer-events: none;
}
.error {
  text-align: center;
}

.help.error {
  color: #EA002A;
}

.welcome-modal {
  border-bottom: 1px solid $border-color;
  padding-bottom: 1.3rem;
}

.signup {
  margin-top: 0.5rem;
}

.enter-code {
  font-family: 'Roboto';
  margin-top: 2rem;
  font-weight: 300;
  font-size: 1rem;
  padding: 0.5rem 0.3rem;
a {
  color: #373737;
  text-decoration: underline;
&:hover {
   color: $link-hover;
 }
@include mobile {
  display: block;
}
}
}

.next-button-container {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: $modal-footer-color;
@include mobile {
  margin: 0;
}
}
.signup-inputs {
  padding-bottom: 1rem;
  width: inherit;
input[type=search] {
  padding-left: 20px;
}
input[type=password] {
&::-webkit-credentials-auto-fill-button {
   width: 0px;
   height: 0px;
   margin: 0;
   display: none !important;
 }
}
@include mobile {
  padding-bottom: 1rem;
}
}

.welcome-modal.title {
  font-size: 1.5rem;
  margin-bottom: 0;
}

input[placeholder] {
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>
<style lang="scss">
</style>
